import { BCMSCurrency, BCMSDate, Branding, useModel } from "@bcm-dev/bcms-vite";
import { Payment } from "model";

export default function Day(props) {
    let { newDate, setDate, currentMonth, controllers } = props;

    const { showFees, billerType, conditionalDisable, dueDate, enablePast ,disableToday,input,disableWeekends} = controllers;
    const { branding } = useModel();

    const isVirtualCard = billerType === "virtualCard";
    const paperFee = BCMSCurrency.toCurrency(branding.options.overnight_check_fee_rxp22 === "undefined" ? "14.95" : branding.options.overnight_check_fee_rxp22);
    const electronicFee = BCMSCurrency.toCurrency(branding.options.same_day_fee_rxp22 === "undefined" ? "9.95" : branding.options.same_day_fee_rxp22);

    const brandingID = billerType === "paper" ? "overnight_check_rxp22" : "same_day_payment_rxp22";
    const brandingValue = billerType === "paper" ? paperFee : electronicFee;
    const rushDeliveryBrandingID = billerType === "paper" ? "overnight_check_rxp22" : "same_day_payment_rxp22";
    let hasRushDelivery = branding.options[rushDeliveryBrandingID] === "true";
    hasRushDelivery = isVirtualCard ? false : hasRushDelivery;
    const feeDate = Payment.getFeeDate(billerType, branding);
    const hasPaperRealTimeGoodFunds = Payment.hasRealTimeGoodFunds(billerType, branding);

    const hasFee = () => {
        // Show fee ui if rush delivery branding is on.
        // Rush delivery is only applied to "paper" or "electronic" biller types.
        if(isVirtualCard) {
            return false;
        } else {
            if(!hasRushDelivery) return false;
        }
        
        if(newDate.monthInt !== currentMonth.monthInt) return false;
        
        // START: "Real Time Good Funds" will not show the fee date for a paper biller.
        if(billerType === "paper" && 
        showFees == "true" && 
        hasPaperRealTimeGoodFunds && 
        newDate.isEqual(feeDate)) {
            return false;
        }
        // END: "Real Time Good Funds" will not show the fee date for a paper biller.

        return showFees == "true" ? newDate.isEqual(feeDate) && newDate.monthInt === currentMonth.monthInt : false;
    }
    const selected = () => input() instanceof BCMSDate ? newDate.isEqual(setDate) && (currentMonth.monthInt == newDate.monthInt):false;
    const label = () => newDate.isToday() && currentMonth.monthInt === newDate.monthInt ? "TODAY" : "";
    const dayLabel = newDate.monthInt !== currentMonth.monthInt ? "" : newDate.dayInt;
    const isDue = () => dueDate !== undefined ? newDate.isEqual(dueDate)&& currentMonth.monthInt === newDate.monthInt : false;

    const disabled = () => {
        const standardDisable = (newDate.isPast() && enablePast ? false : newDate.isPast()) || (disableWeekends === false && newDate.isWeekend() ?false:newDate.isWeekend()) || (currentMonth.monthInt != newDate.monthInt) || newDate.isAfter(BCMSDate.init().offset([0, 0, 1]));
        const todayDisable = disableToday === false && newDate.isToday() ? false : (showFees && billerType === "paper" ? newDate.isToday() : false);
        const defaultPaperDate = BCMSDate.init();
        Array.apply(null, Array(5)).forEach(i => defaultPaperDate.nextBusinessDay());
        let feeDisable = billerType === "paper" ? newDate.isAfter(feeDate) && newDate.isBefore(defaultPaperDate) : false;

        // START: "Real Time Good Funds" will not show the fee date for a paper biller.
        if(billerType === "paper" && 
        showFees == "true" && 
        hasPaperRealTimeGoodFunds && 
        newDate.isEqual(feeDate)) {
            feeDisable = true;
        }
        // END: "Real Time Good Funds" will not show the fee date for a paper biller.

        // Check for disabled dates determined by branding options.
        function disableFeeDateUsingBranding() {
            // Virtual card billers do not have rush delivery.
            if(isVirtualCard) {
                return showFees == "false"
                ? newDate.isEqual(feeDate)
                : false;
            } else {
                return showFees == "false" || hasRushDelivery === false
                ? newDate.isEqual(feeDate)
                : false;
            }
        }

        return disableToday === false && newDate.isToday()
        ? false
        : (standardDisable || feeDisable || todayDisable || disableFeeDateUsingBranding() || conditionalDisable(newDate));
    }

    function onClick(event) {
        event.preventDefault();
        if (disabled() === false) {

            props.onChange(newDate)
            controllers.close();
        }
    }

    const selectedClass = selected() ? "selected" : "";
    const dueClass = isDue() ? "due" : "";

    const selectedPoint = selected() ? { "data-point": "Date_Picker_Selected_Date" } : {};
    const firstDayPoint = newDate.dayInt === 1 && !newDate.isPast() && !newDate.isToday() && !disabled() ? { "data-point": `Date_Picker_First_Of_Month` } : {};

    return (
        <span className="square flex-width">
            <span onClick={onClick} className={"day " + (disabled() ? "grey " : " ")}>
                {/* Use the class hide in the span to hide the today text */}
                <span className={ "day-label" + (newDate.isEqual(feeDate) && hasFee() ? " day-label-top": "") }>
                    {label()}
                </span>

                <span className={ `day-number ${ selectedClass } ${ dueClass }` } { ...selectedPoint } { ...firstDayPoint }>{ dayLabel }</span>

                {hasFee() &&
                    <span className="day-label fee-label" data-point="Date_Picker_Fee">
                        <Branding id={brandingID} value="true">+{brandingValue}</Branding>
                    </span>}

                { isDue() && <span className="day-label due-label">DUE</span> }
            </span>
        </span>
    )
}
